<template>
  <div class="themed-rich-text-editor">
    <vue-editor
      :value="value"
      @input="$emit('input', $event)"
      :editorOptions="computedEditorOptions"
      :class="editorClass"
      @text-change="$emit('text-change', $event)"
      @selection-change="$emit('selection-change', $event)"
      @focus="$emit('focus', $event)"
      @blur="$emit('blur', $event)"
    />
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor';

export default {
  name: 'ThemedRichTextEditor',

  components: {
    VueEditor
  },

  props: {
    value: {
      type: String,
      default: ''
    },
    preset: {
      type: String,
      default: 'standard',
      validator: (value) => ['minimal', 'standard', 'full', 'comment'].includes(value)
    },
    placeholder: {
      type: String,
      default: 'Start typing...'
    },
    customOptions: {
      type: Object,
      default: null
    },
    editorClass: {
      type: String,
      default: ''
    }
  },

  computed: {
    computedEditorOptions() {
      // If custom options provided, use them
      if (this.customOptions) {
        return this.customOptions;
      }

      // Otherwise use preset
      const presets = {
        minimal: {
          modules: {
            toolbar: [
              ['bold', 'italic'],
              ['link']
            ]
          },
          placeholder: this.placeholder,
          theme: 'snow'
        },
        standard: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              ['link'],
              ['clean']
            ]
          },
          placeholder: this.placeholder,
          theme: 'snow'
        },
        full: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'script': 'sub'}, { 'script': 'super' }],
              [{ 'indent': '-1'}, { 'indent': '+1' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }],
              ['clean'],
              ['link', 'image']
            ]
          },
          placeholder: this.placeholder,
          theme: 'snow'
        },
        comment: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              ['link'],
              ['clean']
            ]
          },
          placeholder: this.placeholder,
          theme: 'snow'
        }
      };

      return presets[this.preset] || presets.standard;
    }
  }
};
</script>
